/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

"use client";

import { css } from "@panda/css";

export const EulaAgreementError = ({
	showError,
	eulaCheckbox,
	mustAgreeWarning,
	error,
}: {
	showError: boolean;
	eulaCheckbox: boolean;
	mustAgreeWarning?: string | null;
	error?: string | null;
}): React.JSX.Element => {
	if ((showError && !eulaCheckbox && mustAgreeWarning) || error) {
		return (
			<div
				className={css({
					color: "red",
					textStyle: "paragraphSM",
					textAlign: "center",
					w: "full",
					padding: "eds.dimension.16",
				})}
			>
				{error || mustAgreeWarning}
			</div>
		);
	}
	return <></>;
};
